import React from "react";
import { createRoot } from 'react-dom/client';
import { inject } from '@vercel/analytics';

inject();

import './index.css';
import './styles/bootstrap.min.css'
import './styles/font-awesome.css'
import './styles/normalize.css'
import './styles/templatemo-style.css'

import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);